import React, { useState, useEffect } from "react";
import { FaSave } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2'

const ShiftingKaryawan = () => {
  const navigate = useNavigate();
  const [outletSelected, setOutletSelected]  = useState(null);
  const [outlets, setOutets] = useState([]);
  
  const [periodes, setPeriodes] = useState([]);
  const [periodeSelected, setPeriodeSelected] = useState(null);
  
  const [employeesShifts, setEmployeesShifts] = useState([]);
  const [lastOfDay, setLastOfDay] = useState(null);
  
  const [shiftOptions, setShiftOptions] = useState([]);
  const [shiftingIsUpdated, setShiftingIsUpdated] = useState(false);
  const [saving, setSaving] = useState(false);
  
  const [showAddPeriode, setShowAddPeriode] = useState(false);
  const [showPeriode, setShowPeriode] = useState(false);
  const [payloadJsonPeriode, setPayloadJsonPeriode] = useState({
    "month":0,
    "year":0,
  })
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  
  useEffect(()=>{
    fetchOutlets();
    fetchPeriodes();
    fetchOptionsShift();
  },[]);
  useEffect(()=>{
    console.log("effect Periode selected & outlet", periodeSelected, outletSelected)
    if (periodeSelected !== null && outletSelected) {
      setEmployeesShifts([]);
      fetchEmployeesShift(periodeSelected.id, outletSelected);
    }
  },[periodeSelected, outletSelected]);
  
  const fetchOutlets = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/outlet?per_page=100&page=1&order_by=name`,
        { method: "GET", headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      let jsonResp = await response.json();
      setOutets(jsonResp.data);
      const storedOutletId = localStorage.getItem("id_outlet");
      const role = localStorage.getItem("role")
      if (role !== "owner") {
        setOutletSelected(storedOutletId);
      }else{
        if (jsonResp.data.length >= 1)  {
          setOutletSelected(jsonResp.data[0].id)
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }
  const fetchPeriodes = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/shift/period-shift`,
        { method: "GET", headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      let jsonResp = await response.json();
      setPeriodes(jsonResp.data);
      
      if (jsonResp.data.length > 0) {
        const today = new Date();
        const currentMonth = today.getMonth()+1;
        const currentYear = today.getFullYear();
        const currentPeriod = jsonResp.data.find((period) => period.month === currentMonth && period.year === currentYear);
        console.log("currentPeriode",currentPeriod)
        if (currentPeriod !== undefined) {
          let lastDay = new Date(currentYear, currentMonth, 0);
          setPeriodeSelected(currentPeriod);
          setLastOfDay(lastDay.getDate())
        } else {
          let now = new Date()
          let lastDate = new Date(now.getFullYear(), now.getMonth()+1,0)
          setPeriodeSelected(null);
          setLastOfDay(lastDate.getDate())
        }
      } else {
        let now = new Date()
        let lastDate = new Date(now.getFullYear(), now.getMonth()+1,0)
        setLastOfDay(lastDate.getDate())
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }
  
  const fetchEmployeesShift = async (periodId, outletId) => {
    console.log("fetchEmployeesShift")
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/employee/shift?outlet_id=${outletId}&period_id=${periodId}`,
        { method: "GET", headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      const jsonResp = await response.json();
      if (!jsonResp.data || jsonResp.data.length === 0) {
        setEmployeesShifts([]);
        return;
      }
      let employeesShifted = []
      jsonResp.data.map((employee) => {
        let shifts = []
        for (let i = 1; i <= lastOfDay; i++) {
          let date = new Date(periodeSelected.year, periodeSelected.month-1, i)
          shifts = [...shifts, {
            date: date,
            code: employee.shifts.find((shift) => new Date(shift.day).getDate() === i)?.shift.code || "",
            id: employee.shifts.find((shift) => new Date(shift.day).getDate() === i)?.shift.id || 0,
            name: employee.shifts.find((shift) => new Date(shift.day).getDate() === i)?.shift.name || "",
          }]
        }
        employeesShifted = [...employeesShifted, {
          shifts: shifts,
          id: employee.id,
          full_name: employee.full_name,
        }]
      });
      setEmployeesShifts(employeesShifted);
    } catch (error) {
      console.error("Error fetching shifts:", error);
    }
  }
  
  const fetchOptionsShift = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/shift?page&per_page&order_by&search`,
        { method: "GET", headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      const data = await response.json();
      setShiftOptions(data.data);
    } catch (error) {
      console.error("Error:", error);
    }
  }
  
  const handlePeriodeChange = (e) => {
    const selected = periodes.find((p) => p.id === parseInt(e.target.value));
    let lastDay = new Date(selected.year, selected.month, 0);
    setPeriodeSelected(selected);
    setLastOfDay(lastDay.getDate());
  }
  
  const handleOutletChange = (e) => {
    const selectedOutlet = outlets.find((o) => o.id === parseInt(e.target.value));
    setOutletSelected(selectedOutlet.id);
  }
  
  const handleShiftChange = (employeeId,dIndex,newShift) => {
    setEmployeesShifts(
      (prev) =>
        prev.map((employee)=> employee.id === employeeId ? {
          ...employee,
          shifts: employee.shifts.map((s, index) =>
            index === dIndex ? {
                ...s,
                id: parseInt(newShift),
                code: shiftOptions.find((opt) => opt.id === parseInt(newShift))?.code || "",
                name: shiftOptions.find((opt) => opt.id === parseInt(newShift))?.name || "",
            } : s
          ),
        }: employee)
    );
  }
  
  const handleSaveShifting = async ()=>{
    setSaving(true);
    
    let payload = {
      period_id: periodeSelected.id,
    }
    let payloadEmployee = []
    employeesShifts.map((employee)=>{
      let shifts = [] 
      employee.shifts.map((shift)=>{
        if (shift.id !== 0) {
          let date = new Date(shift.date.getFullYear(), shift.date.getMonth(), shift.date.getDate()+1)
          let day = date.toISOString().split("T")[0]
          shifts = [
            ...shifts,
            {
              shift_id: shift.id,
              day: day,
            }
          ]
        }
      })
      payloadEmployee = [
        ...payloadEmployee,
        {
          employee_id: employee.id,
          shifts: shifts,
        }
      ]
    })
    payload.employees = payloadEmployee
    console.log("payload",payload);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/shift/process-batch-employee-shifting`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(payload),
        }
      );
      
      const result = await response.json();
      console.log("Response:", result);
      
      if (result.success) {
        await Swal.fire({
          title: "Good job!",
          text: result.message,
          icon: "success"
        });
        navigate("/enterprise/karyawan");
      } else {
        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.message,
        });
        setSaving(false);
      }
    }catch(error) {
      console.error("Error:", error);
    }
  }
  
  const handlePreSavePeriode = (e) => {
    const { name, value } = e.target;
    if (name === "year") {
      let year = parseInt(value)
      setPayloadJsonPeriode((prev) => ({ ...prev, [name]: year }));
    }else if (name === "month") {
      let month = parseInt(value)+1
      console.log("handlePreSavePeriode", name, month);
      setPayloadJsonPeriode((prev) => ({ ...prev, [name]: month }));
    }
  };
  const handleSavePeriode = async () => {
    console.log("handleSavePeriode", payloadJsonPeriode);
    let role = localStorage.getItem("role")
    if (role !== "owner") {
      await Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Your Account Is "+role,
      });
    }else{
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/v1/shift/period-shift`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            body: JSON.stringify(payloadJsonPeriode),
          }
        );
        const result = await response.json();
        if (result.success) {
          setShowPeriode(false);
          await Swal.fire({
            title: "Good job!",
            text: result.message,
            icon: "success"
          })
          fetchPeriodes(); // refresh periode
        } else {
          await Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.message,
          });
        }
      } catch (error) {
        console.error("Error adding period:", error);
        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan saat menambahkan periode."+error,
        });
      }
    }
  }
  console.log("periode",periodeSelected)
  return (
    <div className="min-h-screen">
      <div className="grid grid-flow-row rounded-lg sm:px-5 bg-white shadow-md">
        <nav
          className="pt-3 pb-1 text-gray-700"
          aria-label="Breadcrumb">
          <ol className="inline-flex items-center mb-3 space-x-1 md:space-x-2 rtl:space-x-reverse sm:mb-0 font-inter text-16 font-medium">
            <li>
              <div className="flex items-center text-sm font-normal text-gray-400">
                <a href="#" onClick={() => navigate("/")}
                   className="ml-0 hover:text-gray-500">Enterprise</a>
              </div>
            </li>
            <li aria-current="page">
              <div className="flex items-center text-sm font-normal text-gray-400">
                <span>/</span>
                <a href="#" onClick={() => navigate("/enterprise/karyawan")}
                   className="ms-1 md:ms-2 hover:text-gray-500">Karyawan</a>
              </div>
            </li>
            <li aria-current="page">
              <div className="flex items-center text-sm font-normal text-gray-500">
                <span>/</span>
                <span
                  className="mx-1 md:mx-2">Shifting Karyawan</span>
              </div>
            </li>
          </ol>
        </nav>
        <div className="pt-1 pb-3 text-gray-500 text-sm font-normal">
          <span className="font-inter text-14">Tetapkan karyawan anda dengan shift yang ada</span>
        </div>
      </div>
      
      {/* make space 10px */}
      <div className="h-2"></div>
      <div className="bg-white p-6 rounded-2xl shadow-md">
        {/* Filter */}
        <div className="flex flex-col md:flex-row md:items-end gap-6 mb-6">
          <div className="flex flex-row">
            <label className="font-semibold text-sm mb-1 flex items-center gap-1 text-gray-600">
              Outlet
            </label>
            <select
              value={outletSelected||""}
              onChange={handleOutletChange}
              className="ml-2 border border-gray-300 rounded-lg px-3 py-2 text-sm disabled:text-gray-400"
              disabled={localStorage.getItem("role") === "manager"}
            >
              {
                outlets.map((outlet) => (
                  <option key={outlet.id} value={outlet.id}>
                    {outlet.name}
                  </option>
                ))
              }
            </select>
          </div>
          
          <div className="flex flex-row">
            <label className="font-semibold text-sm mb-1 flex items-center gap-1 text-gray-600">
              Periode
            </label>
            <div className="flex gap-2 items-center ml-2">
              {/* New button pilih periode */}
              <div className="relative inline-block text-left">
                <div>
                  <button
                    type="button"
                    onClick={() => {
                      setShowPeriode(!showPeriode);
                      setShowAddPeriode(!showPeriode);
                    }}
                    className="inline-flex w-full justify-center gap-x-1.5 rounded-lg bg-white px-3 py-2 text-sm font-medium text-gray-500 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50"
                    id="menu-button" aria-expanded="true" aria-haspopup="true">
                    {monthNames[periodeSelected?.month - 1]} {periodeSelected?.year}
                    <svg className="-mr-1 size-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                      <path
                        fillRule="evenodd"
                        d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
                
                <div
                  className={`${
                    showPeriode?
                    "":"hidden"
                  } absolute left-0 z-10 mt-2 w-56 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black/5 focus:outline-hidden`}
                  role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex="-1">
                  {
                    !showAddPeriode? (
                      <div className="p-3">
                        <div className="flex flex-row gap-2">
                          <div className="relative">
                            <select
                              name="month"
                              onChange={handlePreSavePeriode}
                              className="block w-full p-2 text-sm text-gray-600 border border-gray-200 rounded-lg bg-gray-50"
                            >
                              <option>Pilih Bulan</option>
                              {
                                monthNames.map((month,index)=>(
                                  <option key={month} value={index}>{month}</option>
                                ))
                              }
                            </select>
                          </div>
                          <div className="relative">
                            <input
                              name="year"
                              onChange={handlePreSavePeriode}
                              type="number"
                              id="input-group-search"
                              className="block w-full p-2 text-sm text-gray-600 border border-gray-200 rounded-lg bg-gray-50"
                              placeholder="Input Tahun"/>
                          </div>
                        </div>
                        <div className="flex flex-row gap-2 mt-2">
                          <button
                            onClick={handleSavePeriode}
                            type="button"
                            className="w-full text-white px-2.5 py-1.5 rounded-lg text-sm bg-green-400 hover:bg-green-500"
                          >
                            Simpan
                          </button>
                          <button
                            onClick={() => {
                              setShowAddPeriode(showPeriode);
                            }}
                            type="button"
                            className="w-10 text-white px-2.5 py-1.5 rounded-lg text-sm bg-gray-400 hover:bg-gray-500"
                          >
                            X
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="p-3">
                        <button
                          onClick={() => {
                            setShowAddPeriode(!showAddPeriode)
                          }}
                          type="button"
                          className="w-full bg-white font-semibold text-gray-400 px-2.5 py-1.5 rounded-lg text-sm hover:bg-gray-100 hover:text-gray-600 hover:font-semibold"
                        >
                          +
                        </button>
                      </div>
                    )
                  }
                  <ul className="py-1 text-sm text-gray-700 dark:text-gray-200" role="none">
                    {periodes.map((periode) => (
                      <li
                        className={`${
                          periodeSelected?.id === periode.id ?
                            "bg-gray-200 text-white" : ""
                        } block font-semibold px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 hover:text-gray-600`}
                        onClick={()=> {
                          setPeriodeSelected(periode)
                          setShowPeriode(!showPeriode);
                        }}
                      >
                        {`${monthNames[periode.month - 1]} ${periode.year}`}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          
          </div>
        </div>
        
        {/* Table */}
        <div className="relative overflow-x-auto shadow-md sm:rounded-md gap-6 mb-6 w-full">
          <table className="min-w-max w-full text-sm">
            <thead className="bg-blue-100 text-gray-600 font-semibold">
            {periodeSelected === null && periodes === [] ? (
              <tr>
                <th className="text-center">Periode Belum di setting</th>
              </tr>
            ) : (
              <tr>
                <th scope="col" className="sticky left-0 z-10 bg-blue-100 p-3 text-center">No</th>
                <th scope="col" className="sticky left-10 z-10 bg-blue-100 p-3 text-left">Nama</th>
                {
                  [...Array(lastOfDay)].map((_, index) => (
                    <th key={index} className="p-3">
                        <span className="block text-xs">
                          {periodeSelected !== null ? (
                            new Date(periodeSelected.year, periodeSelected.month, index + 1).toLocaleDateString(
                              "id-ID", {weekday: "short"}
                            )
                          ) : (
                            ""
                          )}
                        </span>
                      <span className="text-xs">
                          {index + 1}
                        </span>
                    </th>
                  ))
                }
              </tr>
            )}
            
            </thead>
            <tbody>
            {employeesShifts === [] ? (
              <tr key="periode-not-set">
                <td colSpan={lastOfDay + 1} className="text-center p-4 text-gray-500">
                  Belum Ada Karyawan
                </td>
              </tr>
            ) : (
              employeesShifts.map((employeeShifts, i) => (
                <tr key={employeeShifts.id} className="text-center bg-white">
                  <td
                    className="sticky left-0 z-10 bg-white text-gray-600 p-2 font-semibold text-center px-3 font-inter">{i + 1}</td>
                  <td
                    className="sticky left-10 z-10 bg-white text-gray-600 p-2 font-semibold text-left px-3 font-inter">
                    {employeeShifts.full_name}
                  </td>
                  {employeeShifts.shifts.map((shift, index) => {
                    let selectedShift = (shift ? shift.id : 0);
                    let isPast = shift.date < new Date();
                      return (
                        <td>
                          <select
                            value={selectedShift ? selectedShift : 0}
                            disabled={isPast}
                            className="w-15 rounded-md px-2 py-1 text-sm text-gray-500"
                            onChange={(e) => {
                              handleShiftChange(employeeShifts.id, index, e.target.value)
                            }}
                          >
                            <option value="">-</option>
                            {shiftOptions.map((opt) => (
                              <option key={opt.id} value={opt.id}>
                                {opt.code}
                              </option>
                            ))}
                          </select>
                        </td>
                      )})}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        
        {/* Save Button.js */}
        <div className="mt-6 text-right">
          <button
            aria-disabled={shiftingIsUpdated}
            onClick={handleSaveShifting}
            className="inline-flex items-center gap-2 px-5 py-2 rounded-xl text-white shadow-md transition duration-200 bg-green-500 hover:bg-green-600"
          >
            {saving ? (
              <>
                <FaSave className="animate-spin" /> Menyimpan...
              </>
            ) : (
              <>
                <FaSave /> Simpan
              </>
            )}
          </button>
        </div>
      </div>
      
      {/* dropdown periode */}
      <div id="dropdownUsers" className="z-10 hidden bg-white rounded-lg shadow-sm w-60 dark:bg-gray-700">
        <div className="p-3">
          <label htmlFor="input-group-search" className="sr-only">Search</label>
          <div className="relative">
            <div className="absolute inset-y-0 rtl:inset-r-0 start-0 flex items-center ps-3 pointer-events-none">
              <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true"
                   xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                      d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
              </svg>
            </div>
            <input
              type="text"
              id="input-group-search"
              className="block w-full p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Search user"/>
          </div>
        </div>
        <ul className="h-48 py-2 overflow-y-auto text-gray-700 dark:text-gray-200"
            aria-labelledby="dropdownUsersButton">
          <li>
            <a href="#"
               className="flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
              Jese Leos
            </a>
          </li>
          <li>
            <a href="#"
               className="flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
              Robert Gough
            </a>
          </li>
          <li>
            <a href="#"
               className="flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
              Bonnie Green
            </a>
          </li>
          <li>
            <a href="#"
               className="flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
              Leslie Livingston
            </a>
          </li>
          <li>
            <a href="#"
               className="flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
              Michael Gough
            </a>
          </li>
          <li>
            <a href="#"
               className="flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
              Joseph Mcfall
            </a>
          </li>
          <li>
            <a href="#"
               className="flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
              Roberta Casas
            </a>
          </li>
          <li>
            <a href="#"
               className="flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
              Neil Sims
            </a>
          </li>
        </ul>
        <a href="#"
           className="flex items-center p-3 text-sm font-medium text-blue-600 border-t border-gray-200 rounded-b-lg bg-gray-50 dark:border-gray-600 hover:bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-blue-500 hover:underline">
          <svg className="w-4 h-4 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
               viewBox="0 0 20 18">
            <path
              d="M6.5 9a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM8 10H5a5.006 5.006 0 0 0-5 5v2a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-2a5.006 5.006 0 0 0-5-5Zm11-3h-2V5a1 1 0 0 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 0 0 2 0V9h2a1 1 0 1 0 0-2Z"/>
          </svg>
          Add new user
        </a>
      </div>
    </div>
  );
}
export default ShiftingKaryawan;
